import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useCategoriesQuery,
  useCreateItemMutation,
  useEditItemMutation,
} from "../constants/redux/api/api";

const AddMenu = ({ menuOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const type = location?.state?.type;
  const editData = location?.state?.data;
  const [allCategData, setAllCategData] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [selectedCat, setSelectedCat] = useState("");
  const [name, setName] = useState("");
  const [image, setImage] = useState({});
  const [price, setPrice] = useState("");
  const [fileName, setFileName] = useState("hhh");

  const [selectedCatErr, setSelectedCatErr] = useState(false);
  const [nameErr, setNameErr] = useState(false);
  const [imageErr, setImageErr] = useState(false);
  const [priceErr, setPriceErr] = useState(false);

  // RTK QUERY
  const { data: categoryData, isSuccess: isCategSuccess } =
    useCategoriesQuery();
  const [createItem] = useCreateItemMutation();
  const [editItem] = useEditItemMutation();

  useEffect(() => {
    if (isCategSuccess) {
      console.log(categoryData?.result);
      setAllCategData(categoryData?.result);
    }
  }, [categoryData, isCategSuccess]);

  useEffect(() => {
    let tmp = [];
    allCategData?.forEach((el) => {
      tmp.push({
        categoryName: el?.categoryName,
        categoryNameId: el?.categoryNameId,
      });
    });
    setAllCategories(tmp);
  }, [allCategData]);

  const onCategoryChange = (e) => {
    console.log(e?.target?.value);
    setSelectedCat(e?.target?.value);
  };

  const onFoodImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const onSubmit = () => {
    console.log(image);
    if (
      selectedCat === "" ||
      image?.size === undefined ||
      name === "" ||
      price === ""
    ) {
      setSelectedCatErr(true);
      setImageErr(true);
      setNameErr(true);
      setPriceErr(true);
    } else {
      const formData = new FormData();
      formData.append("categoryNameId", selectedCat);
      formData.append("foodname", name);
      formData.append("price", price);
      formData.append("image", image);
      createItem(formData)
        .unwrap()
        .then((res) => {
          if (res?.status === "success") {
            console.log(res);
            navigate(-1);
          }
        })
        .catch((err) => console.log(err));
    }
  };

  const onEditSubmit = () => {
    if (
      selectedCat === "" ||
      // image?.size === undefined ||
      name === "" ||
      price === ""
    ) {
      setSelectedCatErr(true);
      setImageErr(true);
      setNameErr(true);
      setPriceErr(true);
    } else {
      const formData = new FormData();
      formData.append("categoryNameId", selectedCat);
      formData.append("categoryItemid", editData?.id);
      formData.append("food", name);
      formData.append("price", price);
      if (image?.size) {
        formData.append("image", image);
      }
      editItem(formData)
        .unwrap()
        .then((res) => {
          if (res?.status === "success") {
            console.log(res);
            navigate(-1);
          }
        })
        .catch((err) => console.log(err));
    }
  };

  // console.log(location);
  useEffect(() => {
    if (type === "edit") {
      console.log(editData);
      const fileNameTmp = editData?.url?.split("/").pop();
      setFileName(fileNameTmp);
      setPrice(editData?.price);
      setName(editData?.food);
      setSelectedCat(editData?.categoryNameId);
    }
  }, [type, location, editData]);

  return (
    <div
      className={menuOpen ? "side-content2" : "side-content"}
      style={{ transition: "0.5s" }}>
      <div className="menu-list">
        <h1>{type === "edit" ? "Edit Food" : "Add Food"}</h1>
      </div>
      <div className="side_pad">
        <div className="add-food-section">
          <div action="">
            <div className="d-flex flex-wrap">
              <div className="col-md-6 col-12 px-md-3 px-0 position-relative mb-2">
                <label for="">Category</label>
                <select
                  disabled={type === "edit" ? true : false}
                  value={selectedCat}
                  onChange={onCategoryChange}
                  className="form-control form-select"
                  style={{ textTransform: "capitalize" }}
                  aria-label="Default select example">
                  <option hidden selected>
                    Select Category
                  </option>
                  {allCategories?.map((item, ind) => {
                    return (
                      <option key={ind} value={item?.categoryNameId}>
                        {item?.categoryName}
                      </option>
                    );
                  })}
                </select>
                {selectedCat === "" && selectedCatErr && (
                  <p className="err-state">Select category*</p>
                )}
              </div>
              <div className="col-md-6 col-12 px-md-3 px-0 position-relative mb-2">
                <label for="">Food Image</label>
                <input
                  onChange={onFoodImageChange}
                  accept="image/png, image/jpeg, image/jpg, image/webp"
                  type="file"
                  className="form-control"
                />
                {type === "edit" && <p>Current File: {fileName}</p>}
                {image?.size === undefined && imageErr && (
                  <p className="err-state">Select food image*</p>
                )}
              </div>
              <div className="col-md-6 col-12 px-md-3 px-0 position-relative mb-2">
                <label for="">Name</label>
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  className="form-control"
                  placeholder="Enter Food name"
                />
                {name === "" && nameErr && (
                  <p className="err-state">Enter food name*</p>
                )}
              </div>
              <div className="col-md-6 col-12 px-md-3 px-0 position-relative mb-2">
                <label for="">Price</label>
                <input
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                  type="number"
                  className="form-control"
                  placeholder="Enter price"
                />
                {price === "" && priceErr && (
                  <p className="err-state">Enter price*</p>
                )}
              </div>
              <div
                onClick={type === "edit" ? onEditSubmit : onSubmit}
                className="px-md-3 pe-3">
                <input className="btn-submit" type="submit" />
              </div>
              <div onClick={() => navigate(-1)} class="btn-outline">
                <p style={{ margin: 0 }}>Back</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddMenu;
